import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { DateTimePicker } from '@progress/kendo-react-dateinputs';
import type { FieldTypeDefinition, FieldRendererProps } from '../registry';

function DateTimeRenderer({ value, onChange, readOnly }: FieldRendererProps) {
  const dateValue = typeof value === 'string' && value ? new Date(value) : null;
  return (
    <DateTimePicker
      value={dateValue}
      onChange={(e) => onChange(e.value ? e.value.toISOString() : null)}
      disabled={readOnly}
    />
  );
}

export const definition: FieldTypeDefinition = {
  key: 'DTM',
  label: 'Date & Time',
  category: 'input',
  icon: <FontAwesomeIcon icon={faClock} fixedWidth />,
  defaultProps: { label: 'New date & time field', isRequired: false },
  Renderer: DateTimeRenderer,
};
